/*
 * Copyright (c) 2016 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { Component, Directive, EventEmitter, Output } from "@angular/core";
var StackView = (function () {
    function StackView() {
        /**
         * Undocumented experimental feature: inline editing.
         */
        this.editable = false;
        this.save = new EventEmitter(false);
        this._editMode = false;
        this.editingChange = new EventEmitter(false);
    }
    Object.defineProperty(StackView.prototype, "editing", {
        get: function () {
            return this.editable && this._editMode;
        },
        set: function (value) {
            if (this.editable) {
                this._editMode = value;
                this.editingChange.emit(value);
                if (!value) {
                    this.save.emit(null);
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    return StackView;
}());
export { StackView };
/**
 * End of undocumented experimental feature.
 */
StackView.decorators = [
    { type: Component, args: [{
                selector: "clr-stack-view",
                template: "\n        <ng-content select=\"clr-stack-header\"></ng-content>\n        <dl class=\"stack-view\"><ng-content></ng-content></dl>\n    ",
                // Custom elements are inline by default.
                styles: ["\n        :host { display: block; }\n    "]
            },] },
];
/** @nocollapse */
StackView.ctorParameters = function () { return []; };
StackView.propDecorators = {
    'save': [{ type: Output, args: ["clrStackSave",] },],
};
var StackViewCustomTags = (function () {
    function StackViewCustomTags() {
    }
    return StackViewCustomTags;
}());
export { StackViewCustomTags };
// No behavior
// The only purpose is to "declare" the tag in Angular
StackViewCustomTags.decorators = [
    { type: Directive, args: [{ selector: "clr-stack-label, clr-stack-content" },] },
];
/** @nocollapse */
StackViewCustomTags.ctorParameters = function () { return []; };
//# sourceMappingURL=stack-view.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/data/stack-view/stack-view.js
// module id = 39
// module chunks = 4